import request from '@/utils/request'

// 查询信标列表
export function listBeacon(query) {
  return request({
    url: '/system/beacon/list',
    method: 'get',
    params: query,
  })
}

// 查询信标分页
export function pageBeacon(query) {
  return request({
    url: '/system/beacon/page',
    method: 'get',
    params: query,
  })
}

// 查询信标详细
export function getBeacon(data) {
  return request({
    url: '/system/beacon/detail',
    method: 'get',
    params: data,
  })
}

// 新增信标
export function addBeacon(data) {
  return request({
    url: '/system/beacon/add',
    method: 'post',
    data: data,
  })
}

// 修改信标
export function updateBeacon(data) {
  return request({
    url: '/system/beacon/edit',
    method: 'post',
    data: data,
  })
}

// 删除信标
export function delBeacon(data) {
  return request({
    url: '/system/beacon/delete',
    method: 'post',
    data: data,
  })
}

// 导入信标数据
export function importBeaconData(data) {
  return request({
    url: '/system/beacon/importData',
    method: 'post',
    data: data,
  })
}

// 修改信标状态
export function changeBeaconStatus(data) {
  return request({
    url: '/system/beacon/editStatus',
    method: 'post',
    data: data,
  })
}
